import { Data } from '../partner/data';

export function formatDateMiliseconds(data) {
  return Data.toMilissegundos(data);
}

export function formatDate(data) {
  return formatDateMiliseconds(data);
}

export function getFone(data) {
  if (data) {
    return {
      ddd: data.toString().substring(1, 3),
      numero: data.toString().substring(4)
    };
  }
}

export function getFoneEmpresa(data) {
  if (data) {
    return {
      ddd: data.toString().substring(0, 2),
      numero: data.toString().substring(2)
    };
  }
}

export function getFoneArray(data) {
  return Object.keys(data).map(item => {
    if (data[item]) {
      return {
        ddd: data[item].toString().substring(1, 3),
        numero: data[item].toString().substring(4)
      };
    }
  });
}

// ------------------

// ------------------

export function allTelefones(data) {
  return  Object.keys(data).map((item) => {
    return {
      idCategoria: (function () {
        if (item === 'residencial') {
          return '1';
        }
        if (item === 'comercial') {
          return '14';
        }
        if (item === 'celularAdicional') {
          return '11';
        }
        return '3';
      })(),
      ddd: (function () {
        if (data[item]) {
          return data[item].substring(0, 2);
        }
        return '';
      })(),
      numero: (function () {
        if (data[item]) {
          return data[item].substring(2);
        }
        return '';
      })(),
      idTipoTelefone: (function () {
        if (item === 'celular') {
          return '1';
        }
        return '2';
      })(),
    };
  }).filter(x => x.numero !== null && x.numero !== undefined && x.numero !== '');
}

export function isEmptyObj(obj) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
}

export function findDuplicates(arr) {
  const sorted_arr = arr.slice().sort();
  const results = [];
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1].email === sorted_arr[i].email && sorted_arr[i].email !== null) {
      results.push(sorted_arr[i]);
    }
  }
  return results;
}

export function parseMoneyInput(inputValue: string): number {
  const onlyDigits = String(inputValue).replace(/\D/g, '');
  const padded = onlyDigits.padStart(3, '0');
  const reais = padded.slice(0, -2);
  const centavos = padded.slice(-2);
  const numeric = Number(reais + centavos) / 100;
  return numeric;
}

export function onlyDigits(inputValue: string): string {
  return String(inputValue).replace(/\D/g, '');
}
